// extracted by css-extract-rspack-plugin
export default {"cls1":"Home-cls1_LD9","cls2":"Home-cls2_cib Home-cls1_LD9"};